import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_METHOD_LB_WINS } from 'api/notificationManager/methods';

export default class LeaderBoardWinsRequest extends WsBaseRequest {
  constructor(data: any) {
    super(API_METHOD_LB_WINS, data);
  }
}
